import { h } from 'preact';

import Skeleton from '@mui/material/Skeleton';

export default function LazyPercentileChart(_props) {
  return (
    <>
      <p>
        <Skeleton height={23} width={200} />
      </p>
      <Skeleton variant="rounded" height={150} width={'100%'} />
    </>
  );
}
